import { FC, ReactNode } from 'react';
import { Form } from 'rsuite';
import { RsSelect, SelectDataType } from 'components/Rsuite/Select';
import RsTooltip from 'components/Rsuite/Tooltip/Tooltip';
import styles from './brandSelection.module.scss';
import { useCampaignStore } from 'store/campaignStore';
interface BrandSelectionProps {
  data: SelectDataType[];
  value: string | null;
  helpText?: ReactNode;
  onChange: (s: string | null) => void;
  errorMessage: { limitations?: string; autoProducts?: string } | undefined;
}

export const BrandSelection: FC<BrandSelectionProps> = ({
  data = [],
  value,
  helpText,
  onChange,
  errorMessage,
}) => {
  const { lockBrand } = useCampaignStore();
  const error = errorMessage?.limitations || errorMessage?.autoProducts;
  return (
    <>
      <div className='mb-1 flex items-center gap-[8px]'>
        <div className='flex items-center gap-[4px]'>
          <span>品牌選擇</span>
          <RsTooltip>
            <span>智能選品僅會投放您所選品牌的相關商品</span>
          </RsTooltip>
        </div>
        <RsSelect
          data={data}
          value={value}
          onChange={onChange}
          className={styles['brand-select']}
          placeholder='請選擇'
          errorMessage={error}
          cleanable={false}
          disabled={lockBrand}
        />
      </div>
      <Form.HelpText>{helpText}</Form.HelpText>
    </>
  );
};
